import { render, staticRenderFns } from "./RegistryConfigs.vue?vue&type=template&id=4245bda8&"
import script from "./RegistryConfigs.vue?vue&type=script&lang=js&"
export * from "./RegistryConfigs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports